/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { List, Typography, Button, IconButton, Tooltip, Modal, Dialog } from "@material-ui/core";
import { Create, Clear } from "@material-ui/icons";
import Pagination from "@material-ui/lab/Pagination";
import { Scrollbars } from "react-custom-scrollbars";
import { FormattedMessage } from "react-intl";
import cn from "classnames";
import { useLocation } from "react-router";
import { browserHistory } from "../../../../routes/history";

import BackButton from '../../../../components/BackButton';
import { ConfirmDialog } from "../../../../components/ConfirmDialog";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import { useNews } from "../../shared";
import NewsInputForm from "../../components/NewsInputForm/NewsInputForm";
import { styles } from "./styles";
import { PAGINATION_SIZE } from "./constants";
import messages from "./messages";
import { News } from "../../shared";
import { useIsAdmin } from "../../../user";
import moment from "moment";

type Props = WithStyles<typeof styles>;

const AllNewsPage: React.FC<Props> = (props: Props) => {
  const itemHeights: number[] = []

  const [news, , , , deleteNews] = useNews();
  const [isAdmin] = useIsAdmin();
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [itemToEdit, setItemToEdit] = React.useState<News | null>(null);
  const [currentPage, setCurrentPage] = React.useState<number>(0);
  const [selectedId, setSelectedId] = React.useState<number | null>(null);
  const [scrollHeight, setScrollHeight] = React.useState<number>(0)
  const [listItemsHeights, setListItemsHeights] = React.useState<number[]>([])
  const scrollbarRef = React.useRef(null)
  const { classes } = props;

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const selectedNews = useQuery().get("id");

  if (selectedNews && news.length) {
    const selectedNewsId = parseInt(selectedNews);
    if (selectedNewsId !== selectedId) {
      setSelectedId(selectedNewsId);
    }
    browserHistory.replace("/news");
  }

  React.useEffect(() => {
    if (selectedId !== null) {
      const index = news.findIndex((item) => item.id === selectedId);
      const pageToSet = Math.floor(index / PAGINATION_SIZE);
      setCurrentPage(pageToSet)
    }
  }, [selectedId]);

  React.useEffect(() => {
    const itemHeightsSum = itemHeights.length? itemHeights.reduce((acc, value) => (acc + value)) : 0
    if (itemHeightsSum === scrollHeight) {
      setListItemsHeights(itemHeights)
    }
  }, [scrollHeight]);

  const refCallback = (element) => {
    if (element) {
      const height = element.offsetHeight
      itemHeights.push(height)
    }
  }

  const editNews = (id: number) => () => {
    const idToSet = news.find((item) => item.id === id);
    setItemToEdit(idToSet!);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setItemToEdit(null);
  };

  const handleOpenDialog = (id: number) => () => {
    const idToSet = news.find((item) => item.id === id);
    setItemToEdit(idToSet!);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setItemToEdit(null);
  };

  const handleDeleteNews = () => {
    if (itemToEdit) {
      deleteNews(itemToEdit.id);
    }
    setDialogOpen(false);
  };

  const getCurrentPage = (event: any, page: number) => {
    const pageToSet = page - 1;
    setCurrentPage(pageToSet);
  };

  const getSlicedNews = () => {
    if (news.length) {
      const paginationOffset = currentPage * PAGINATION_SIZE;
      const slicedNews = news.slice(paginationOffset, paginationOffset + PAGINATION_SIZE);
      return slicedNews;
    }
    return [];
  };

  const handleScrollFrame = (values) => {
    if(values.scrollHeight !== scrollHeight) {
      setScrollHeight(values.scrollHeight)
    }
  }

  const pageCount = Math.ceil(news.length / PAGINATION_SIZE);
  const slicedNews = getSlicedNews();

  if (scrollbarRef && listItemsHeights.length && selectedId) {
    const selectedItem = slicedNews.find(item => item.id === selectedId);
    if (selectedItem) {
      const selectedItemIndex = slicedNews.indexOf(selectedItem);
      const topNews = listItemsHeights.slice(0, selectedItemIndex);
      const topNewsHeight: number = topNews.reduce((acc, value) => (acc + value), 0);
      (scrollbarRef.current as Scrollbars)!.scrollTop(topNewsHeight)
    }
  }

  window["scrollTo"](0,0);

  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.titleGroup}>
            <BackButton/>
            <Typography className={classes.newsTypo}>
              <FormattedMessage {...messages.header} />
            </Typography>
          </div>
          {isAdmin && (
            <div className={classes.controlsContainer}>
              <Button
                color="primary"
                variant="contained"
                className={classes.newsButton}
                onClick={() => setModalOpen(true)}
              >
                <FormattedMessage {...messages.addNew} />
              </Button>
            </div>
          )}
          <div className={classes.newsListContainer}>
            <Scrollbars ref={scrollbarRef} hideTracksWhenNotNeeded onUpdate={handleScrollFrame} >
              <List classes={{ root: classes.list }}>
                {slicedNews.map((item, index) => (
                  <div key={index} id={`listItem${index}`} ref={refCallback} className={classes.card}>
                    <div className={classes.header}>
                      <div className={classes.headerText}>
                        <Typography className={classes.dateTypo}>
                          {moment(item.createdDate).format("MMMM DD, YYYY")}
                        </Typography>
                        <Typography className={classes.captionTypo}>{item.caption}</Typography>
                      </div>
                      {isAdmin && (
                        <div className={classes.buttonBase}>
                          <Tooltip title="Edit">
                            <IconButton onClick={editNews(item.id)} size="small">
                              <Create fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton onClick={handleOpenDialog(item.id)} size="small">
                              <Clear fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                    <Typography className={classes.descriptionTypo}>{item.description}</Typography>
                  </div>
                ))}
              </List>
            </Scrollbars>
            <div className={classes.paginationRoot}>
              <Pagination onChange={getCurrentPage} count={pageCount} />
            </div>
          </div>
        </div>
      </div>
      <Modal open={modalOpen} onClose={closeModal}>
        <NewsInputForm itemToEdit={itemToEdit} onClose={closeModal} />
      </Modal>
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <ConfirmDialog
          content={messages.confirmDialogContent}
          actions={{
            yesMessage: messages.confirmDialogBtnYes,
            noMessage: messages.confirmDialogBtnNo,
            handleYes: handleDeleteNews,
          }}
          handleCloseDialog={handleCloseDialog}
        />
      </Dialog>

      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(AllNewsPage);
